import { useQuery } from '@tanstack/react-query';
import { CommonResponse, CommonResponseList } from 'src/model/common';
import { VesselDetail, Vessels } from 'src/model/vessels';
import { VesselsService } from 'src/services/api/vessels';

const QUERY_KEY_VESSELS = "QUERY_KEY_VESSELS"
const QUERY_KEY_VESSEL_DETAIL = "QUERY_KEY_VESSEL_DETAIL"
const QUERY_KEY_SUMMARY_VESSELS = "QUERY_KEY_SUMMARY_VESSELS"
const QUERY_KEY_VESSEL_DETAIL_RECENT_SPEED = "QUERY_KEY_VESSEL_DETAIL_RECENT_SPEED"
const QUERY_KEY_VESSEL_DETAIL_RECENT_DRAUGHT = "QUERY_KEY_VESSEL_DETAIL_RECENT_DRAUGHT"
export const useQueryVessels = (params: Record<string, any>) => {
  const { data, isFetching } = useQuery({
    queryKey: [QUERY_KEY_VESSELS, params],
    queryFn: () => VesselsService.getVessels(params),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    initialData: new Vessels(),
    placeholderData: (previousData) => previousData,
  })

  return {
    data, isFetching
  }
}
export const useQuerySummaryVesselDetail = ({ mmsi }: { mmsi: string }) => {
  const { data, isFetching } = useQuery({
    queryKey: [QUERY_KEY_VESSEL_DETAIL],
    queryFn: () => VesselsService.getVesselDetail(mmsi),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    initialData: new VesselDetail(),
    placeholderData: (previousData) => previousData,
  })
  return {
    data, isFetching
  }
}
export const useQuerySummaryVessels = () => {
  const { data, isFetching } = useQuery({
    queryKey: [QUERY_KEY_SUMMARY_VESSELS],
    queryFn: () => VesselsService.getSummaryVessels(),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    initialData: new CommonResponse(),
    placeholderData: (previousData) => previousData,
  })

  return {
    data, isFetching
  }
}
export const useQueryVesselDetailMetrics = (params: Record<string, any>) => {
  const recentSpeed = useQuery({
    queryKey: [QUERY_KEY_VESSEL_DETAIL_RECENT_SPEED, params],
    queryFn: () => VesselsService.getVesselDetailRecentSpeed(params),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    initialData: new CommonResponseList(),
    placeholderData: (previousData) => previousData,
  })
  const recentDraught = useQuery({
    queryKey: [QUERY_KEY_VESSEL_DETAIL_RECENT_DRAUGHT],
    queryFn: () => VesselsService.getVesselDetailRecentDraught(params),
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    initialData: new CommonResponseList(),
    placeholderData: (previousData) => previousData,
  })

  return {
    recentSpeed, recentDraught
  }
}